import { RegisterOptions } from 'react-hook-form';

export const createRequiredRules = (message: string): RegisterOptions => ({
  required: { value: true, message },
});
